import { TypographyOptions } from '@mui/material/styles/createTypography'

export const typography: TypographyOptions = {
    fontFamily: `'Titillium Web', 'sans-serif'`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    h1: {
        fontSize: 48,
        letterSpacing: -1.5,
        color: 'white',
        fontWeight: 600,
    },
    h2: {
        fontSize: 26,
        letterSpacing: -0.5,
        color: 'white',
        fontWeight: 600,
    },
    h3: {
        fontSize: 20,
        letterSpacing: 0,
        color: 'white',
        fontWeight: 600,
        lineHeight: 1.24,
    },
    h4: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: 'white',
        fontWeight: 600,
    },
    h5: {
        fontSize: 14,
        letterSpacing: 0,
        color: 'white',
        fontWeight: 600,
    },
    h6: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: 'white',
    },
    body1: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: 'white',
    },
    body2: {
        fontSize: 12,
        letterSpacing: 0.25,
        color: 'white',
    },
    caption: {
        fontSize: 12,
        letterSpacing: 0.25,
        color: 'white',
    },
    button: {
        fontSize: 14,
        textTransform: 'uppercase',
        fontWeight: 600,
    },
}
